export enum UserRegisterTypeEnum {
    BORROWER = 1,
    LENDER = 2,
    NEUTRAL = 3,
    OLD_USER = 4
}